/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import MedicationSchedule from './medication-schedule';
import MedicationScheduleDetail from './medication-schedule-detail';
import MedicationScheduleUpdate from './medication-schedule-update';
import MedicationScheduleDeleteDialog from './medication-schedule-delete-dialog';

const MedicationScheduleRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<MedicationSchedule />} />
    <Route path="new" element={<MedicationScheduleUpdate />} />
    <Route path=":id">
      <Route index element={<MedicationScheduleDetail />} />
      <Route path="edit" element={<MedicationScheduleUpdate />} />
      <Route path="delete" element={<MedicationScheduleDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default MedicationScheduleRoutes;
